module.exports = __webpack_public_path__ + "static/media/bikash_kc.531fcc0a.jpg";